/* BIS_V1 — "Notify me when available" (Notre Succès, Teo 4 Oct 2026).
   Selected variant not buyable (and therefore not a STOQ pre-order) -> the sold-out button is swapped for
   "Notify me when available" -> modal (desktop) / bottom sheet (phone) -> Klaviyo client event
   "NS Notify Me Requested" (public key). No libraries, no pixels. */
(function () {
  'use strict';
  var dataEl = document.getElementById('bis-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.variants || !D.variants.length) return;

  var STORE_KEY = 'bis:requested';
  var form = document.getElementById('product_form');
  if (!form) return;
  var atc = form.querySelector('.addToCart');
  if (!atc) return;
  var section = form.closest('[data-section-id]') || document;
  var byId = {};
  D.variants.forEach(function (v) { byId[String(v.id)] = v; });
  var single = D.variants.length === 1 && /^default title$/i.test(D.variants[0].title);

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function requested() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function remember(id) { try { var r = requested(); r[id] = Date.now(); localStorage.setItem(STORE_KEY, JSON.stringify(r)); } catch (e) {} }

  /* ---------- which variant is selected ---------- */
  function currentVariant() {
    var opts = [];
    section.querySelectorAll('.product-varient-input:checked').forEach(function (inp) {
      opts[parseInt(inp.getAttribute('data-option-index'), 10)] = inp.getAttribute('data-raw-value');
    });
    if (opts.length) {
      var m = D.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
      if (m.length === 1) return m[0];
    }
    var idEl = form.querySelector('[name="id"]');
    if (idEl && byId[String(idEl.value)]) return byId[String(idEl.value)];
    var u = new URLSearchParams(location.search).get('variant');
    if (u && byId[u]) return byId[u];
    return D.variants[0];
  }
  function sizeLabel(v) {
    if (single) return '';
    var i = D.size_index;
    return (i >= 0 && v.options[i] != null) ? v.options[i] : v.title;
  }
  function otherOptions(v) {
    var i = D.size_index;
    return v.options.filter(function (o, k) { return k !== i; }).join(' / ');
  }
  /* sold-out siblings of v that share every non-size option (same colour) */
  function soldOutSiblings(v) {
    if (single) return [v];
    var i = D.size_index;
    return D.variants.filter(function (x) {
      if (x.available) return false;
      return x.options.every(function (o, k) { return k === i || o === v.options[k]; });
    });
  }
  function isNotifyState(v) {
    if (!v || v.available || v.preorder) return false;
    /* belt and braces: STOQ owns the button -> it is a live pre-order, never show notify */
    if (atc.classList.contains('restock-rocket-preorder-button')) return false;
    return true;
  }

  /* ---------- the trigger button (replaces the sold-out button) ---------- */
  var trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'bis-trigger';
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.hidden = true;
  trigger.innerHTML =
    '<svg class="bis-trigger__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M6 9.5a6 6 0 1 1 12 0c0 4.6 1.6 6.4 2.3 7H3.7c.7-.6 2.3-2.4 2.3-7Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
    '<path d="M10 19.6a2.1 2.1 0 0 0 4 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
    '<b class="bis-trigger__text">Notify me when available</b><i class="bis-ripple" aria-hidden="true"></i>';
  atc.parentNode.insertBefore(trigger, atc.nextSibling);
  var triggerText = trigger.querySelector('.bis-trigger__text');

  var sticky = document.querySelector('[data-ns-sticky-add]');
  var state = { on: false, v: null };

  function sync() {
    var v = currentVariant();
    var on = isNotifyState(v);
    state.on = on; state.v = v;
    trigger.hidden = !on;
    form.classList.toggle('bis-active', on);
    if (on) {
      var done = requested()[String(v.id)];
      triggerText.textContent = done ? 'You’re on the list' : 'Notify me when available';
      trigger.classList.toggle('is-done', !!done);
    }
    if (sticky) {
      if (on) {
        if (sticky.textContent !== 'Notify me') sticky.textContent = 'Notify me';
        sticky.classList.add('bis-sticky');
      } else if (sticky.classList.contains('bis-sticky')) {
        sticky.classList.remove('bis-sticky');
        /* the theme rewrites its own label on the next variant change; restore a sane default now */
        if (sticky.textContent === 'Notify me') sticky.textContent = v && v.available ? (v.preorder ? ((window.stockTexts || {}).preorderBtn || 'Pre-order') : (sticky.getAttribute('data-ns-default-label') || 'Add to cart')) : 'Sold out';
      }
    }
  }
  var raf = 0;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }

  section.addEventListener('change', function () { setTimeout(schedule, 0); }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-varient-label, .product-varient-input')) setTimeout(schedule, 30);
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(atc, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
    if (sticky) new MutationObserver(function () { if (state.on && sticky.textContent !== 'Notify me') schedule(); }).observe(sticky, { childList: true, characterData: true, subtree: true });
    var idEl = form.querySelector('[name="id"]');
    if (idEl) new MutationObserver(schedule).observe(idEl, { attributes: true });
  }
  window.addEventListener('pageshow', schedule);
  sync();

  if (sticky) {
    sticky.addEventListener('click', function (e) {
      if (!state.on) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open(sticky);
    }, true);
  }
  trigger.addEventListener('click', function () { open(trigger); });

  /* ---------- dialog ---------- */
  var root, panel, lastFocus, chosen;
  var ICON_CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var ICON_OK = '<svg width="44" height="44" viewBox="0 0 48 48" fill="none" aria-hidden="true"><circle cx="24" cy="24" r="22.5" stroke="currentColor" stroke-width="1"/><path class="bis-ok-path" d="M15.5 24.5l6 6 11-13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function build() {
    root = document.createElement('div');
    root.className = 'bis-root';
    root.hidden = true;
    root.innerHTML =
      '<div class="bis-backdrop" data-bis-close></div>' +
      '<div class="bis-panel" role="dialog" aria-modal="true" aria-labelledby="bis-title" aria-describedby="bis-sub">' +
        '<div class="bis-grab" aria-hidden="true"></div>' +
        '<button type="button" class="bis-close" data-bis-close aria-label="Close">' + ICON_CLOSE + '</button>' +
        '<div class="bis-view bis-view--form">' +
          '<p class="bis-eyebrow">Notify me</p>' +
          '<h2 class="bis-title" id="bis-title">Be the first to know</h2>' +
          '<p class="bis-sub" id="bis-sub">Leave your email and we’ll let you know the moment it’s back — in stock or for pre-order.</p>' +
          '<div class="bis-product">' +
            '<div class="bis-thumb"><img alt="" width="160" height="200" decoding="async"></div>' +
            '<div class="bis-product__info">' +
              '<p class="bis-product__title"></p>' +
              '<p class="bis-product__meta"></p>' +
              '<p class="bis-product__price"></p>' +
            '</div>' +
          '</div>' +
          '<form class="bis-form" novalidate>' +
            '<fieldset class="bis-sizes" hidden>' +
              '<legend class="bis-label">Size</legend>' +
              '<div class="bis-size-list" role="radiogroup"></div>' +
            '</fieldset>' +
            '<div class="bis-field">' +
              '<label class="bis-label" for="bis-email">Email</label>' +
              '<input class="bis-input" id="bis-email" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="you@example.com" required aria-describedby="bis-error">' +
            '</div>' +
            '<input class="bis-hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
            '<label class="bis-check">' +
              '<input type="checkbox" name="news">' +
              '<span class="bis-check__box" aria-hidden="true"></span>' +
              '<span class="bis-check__text">Also get Notre Succès news</span>' +
            '</label>' +
            '<p class="bis-error" id="bis-error" role="alert" aria-live="assertive"></p>' +
            '<button type="submit" class="bis-submit"><span class="bis-submit__text">Notify me</span><span class="bis-spinner" aria-hidden="true"></span></button>' +
            '<p class="bis-fine">We’ll only email you about this piece. <a href="/policies/privacy-policy">Privacy</a></p>' +
          '</form>' +
        '</div>' +
        '<div class="bis-view bis-view--done" hidden>' +
          '<div class="bis-ok">' + ICON_OK + '</div>' +
          '<h2 class="bis-title bis-title--done" tabindex="-1">You’re on the list</h2>' +
          '<p class="bis-sub bis-done-text">We’ll email you as soon as it’s back.</p>' +
          '<p class="bis-done-item"></p>' +
          '<button type="button" class="bis-secondary" data-bis-close>Continue shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    panel = root.querySelector('.bis-panel');
    root.addEventListener('click', function (e) { if (e.target.closest('[data-bis-close]')) close(); });
    root.addEventListener('keydown', onKey);
    root.querySelector('.bis-form').addEventListener('submit', onSubmit);
    root.querySelector('.bis-size-list').addEventListener('keydown', onSizeKey);
    swipeToClose();
  }

  function fill(v) {
    chosen = v;
    var img = panel.querySelector('.bis-thumb img');
    img.src = (v.image || D.image || '').replace(/width=\d+/, 'width=240');
    img.alt = D.title;
    panel.querySelector('.bis-product__title').textContent = D.title;
    var other = single ? '' : otherOptions(v);
    panel.querySelector('.bis-product__meta').innerHTML = (other ? esc(other) + '<span class="bis-dot" aria-hidden="true">·</span>' : '') + '<span class="bis-soldout">Sold out</span>';
    panel.querySelector('.bis-product__price').textContent = v.price_display || '';
    var fs = panel.querySelector('.bis-sizes');
    var list = panel.querySelector('.bis-size-list');
    var sibs = soldOutSiblings(v);
    if (single || !sibs.length) { fs.hidden = true; list.innerHTML = ''; return; }
    fs.hidden = false;
    list.innerHTML = sibs.map(function (s) {
      var sel = String(s.id) === String(v.id);
      return '<button type="button" role="radio" class="bis-size' + (sel ? ' is-selected' : '') + '" aria-checked="' + sel + '" tabindex="' + (sel ? 0 : -1) + '" data-id="' + s.id + '">' + esc(sizeLabel(s)) + '</button>';
    }).join('');
    list.querySelectorAll('.bis-size').forEach(function (b) {
      b.addEventListener('click', function () { pickSize(b.getAttribute('data-id')); });
    });
  }
  function pickSize(id) {
    var v = byId[String(id)]; if (!v) return;
    chosen = v;
    panel.querySelectorAll('.bis-size').forEach(function (b) {
      var sel = b.getAttribute('data-id') === String(id);
      b.classList.toggle('is-selected', sel);
      b.setAttribute('aria-checked', sel);
      b.tabIndex = sel ? 0 : -1;
      if (sel) b.focus();
    });
    panel.querySelector('.bis-product__price').textContent = v.price_display || '';
  }
  function onSizeKey(e) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!(e.key in keys)) return;
    e.preventDefault();
    var bs = Array.prototype.slice.call(panel.querySelectorAll('.bis-size'));
    var i = bs.findIndex(function (b) { return b.classList.contains('is-selected'); });
    var n = bs[(i + keys[e.key] + bs.length) % bs.length];
    if (n) pickSize(n.getAttribute('data-id'));
  }

  function open(from) {
    var v = state.v || currentVariant();
    if (!isNotifyState(v)) return;
    if (!root) build();
    lastFocus = from || document.activeElement;
    showView('form');
    fill(v);
    var err = panel.querySelector('.bis-error'); err.textContent = '';
    panel.querySelector('.bis-input').removeAttribute('aria-invalid');
    try { var em = localStorage.getItem('bis:email'); if (em && !panel.querySelector('.bis-input').value) panel.querySelector('.bis-input').value = em; } catch (e) {}
    root.hidden = false;
    document.documentElement.classList.add('bis-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () {
      var target = window.matchMedia('(hover: none)').matches ? panel.querySelector('.bis-close') : panel.querySelector('.bis-input');
      (target || panel).focus({ preventScroll: true });
    }, 60);
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bis-lock');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { root.hidden = true; panel.style.transform = ''; }, reduce ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    sync();
  }
  function showView(which) {
    panel.querySelector('.bis-view--form').hidden = which !== 'form';
    panel.querySelector('.bis-view--done').hidden = which !== 'done';
    panel.setAttribute('aria-labelledby', 'bis-title');
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('button, input:not(.bis-hp), a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function swipeToClose() {
    var y0 = null, dy = 0;
    var grab = panel.querySelector('.bis-grab');
    function start(e) { if (window.innerWidth >= 768) return; y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }
    function move(e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }
    function end() { if (y0 == null) return; panel.style.transition = ''; y0 = null; if (dy > 90) close(); else panel.style.transform = ''; }
    [grab, panel.querySelector('.bis-eyebrow')].forEach(function (el) {
      if (!el) return;
      el.addEventListener('touchstart', start, { passive: true });
      el.addEventListener('touchmove', move, { passive: true });
      el.addEventListener('touchend', end);
    });
  }

  /* ---------- submit -> Klaviyo client API ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(D.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-07-15' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function onSubmit(e) {
    e.preventDefault();
    var f = e.target;
    var input = f.querySelector('.bis-input');
    var err = f.querySelector('.bis-error');
    var btn = f.querySelector('.bis-submit');
    if (f.querySelector('.bis-hp').value) return;           /* bot */
    var email = (input.value || '').trim().toLowerCase();
    if (!EMAIL_RE.test(email)) {
      err.textContent = 'Please enter a valid email address.';
      input.setAttribute('aria-invalid', 'true'); input.focus();
      return;
    }
    input.removeAttribute('aria-invalid'); err.textContent = '';
    var v = chosen || state.v;
    var news = f.querySelector('[name="news"]').checked;
    var vt = single ? '' : v.title;
    var props = {
      product_id: String(D.product_id),
      product_handle: D.handle,
      product_title: D.title,
      variant_id: String(v.id),
      variant_title: vt,
      product_url: D.url + '?variant=' + v.id,
      image_url: v.image || D.image,
      price: (typeof v.price === 'number' ? v.price.toFixed(2) : String(v.price)),
      currency: D.currency,
      price_display: v.price_display,
      marketing_opt_in: news,
      source: 'notify-me'
    };
    btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    var ev = {
      data: { type: 'event', attributes: {
        properties: props,
        unique_id: 'bis-req-' + v.id + '-' + email + '-' + Date.now(),
        metric: { data: { type: 'metric', attributes: { name: 'NS Notify Me Requested' } } },
        profile: { data: { type: 'profile', attributes: { email: email, properties: { '$source': 'notify-me' } } } }
      } }
    };
    var jobs = [post('events', ev)];
    if (news) {
      jobs.push(post('subscriptions', {
        data: { type: 'subscription', attributes: {
          custom_source: 'Notify me (product page)',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: D.list } } } }
      }).catch(function () { /* the notify request is what matters */ }));
    }
    Promise.all(jobs).then(function () {
      remember(String(v.id));
      try { localStorage.setItem('bis:email', email); } catch (x) {}
      panel.querySelector('.bis-done-item').textContent = D.title + (vt ? ' — ' + vt : '');
      showView('done');
      var t = panel.querySelector('.bis-title--done'); if (t) t.focus({ preventScroll: true });
    }).catch(function () {
      err.textContent = 'Something went wrong. Please try again.';
    }).then(function () {
      btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
    });
  }

  /* expose for QA only */
  window.__bis = { open: function () { open(trigger); }, sync: sync, state: state };
})();
